import script from "./LanguageSelectorBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelectorBar.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelectorBar.vue?vue&type=style&index=0&id=2a40be0a&scoped=true&lang=css"
import "./LanguageSelectorBar.vue?vue&type=style&index=1&id=2a40be0a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a40be0a"]])

export default __exports__